import {FC, useState} from 'react'
import clsx from 'clsx'
import {Stt} from '../../core/_models'

export interface SttMessageModel {
  end?: number
  text?: string
  start?: number
  channel?: number
  segment?: number
}

type Props = {
  stt?: Stt
  playSegment: (start: number, stop: number) => void
}

const TalkInnerTab: FC<Props> = ({stt, playSegment}) => {
  const [messages] = useState<SttMessageModel[]>(stt?.segments as SttMessageModel[])

  return (
    <>
      <div id={'transcription-scroll'} className='card-body overflow-auto m-h-40vh' style={{maxHeight: '100%'}}>
        <div className='d-flex w-100 gap-1'>
          <div className='flex-column-fluid scroll-y'>
            {messages.map((message, index) => {
              const state = message.channel === 0 ? 'info' : 'primary'
              const templateAttr = {}
              const contentClass = `justify-content-${message.channel === 0 ? 'start' : 'end'} mb-6`

              return (
                <div
                  id={`segment-${message.segment}`}
                  data-sec={message.start?.toFixed(0)}
                  key={`message${index}`}
                  className={clsx('d-flex', contentClass, {'d-none': false})}
                  {...templateAttr}
                >
                  <div
                    className={clsx(
                      'd-flex flex-column align-items',
                      `align-items-${message.channel === 0 ? 'start' : 'end'}`
                    )}
                  >
                    <div className='d-flex align-items-center mb-2'>
                      <div className='d-flex align-items-center ms-3'>
                        <span className={clsx('badge', `bg-light-${state}`, 'text-gray-900', 'me-1')}>
                          канал: {message.channel}
                        </span>
                        <span className={clsx('badge', `bg-light-${state}`, 'text-gray-900', 'me-1')}>
                          сегмент: {message.segment}
                        </span>
                        <span className={clsx('badge', `bg-light-${state}`, 'text-gray-900', 'me-1')}>
                          {message.start} сек - {message.end} сек
                        </span>
                        <button
                          className='btn btn-sm btn-light-primary btn-active-light-primary btn-active-text-muted d-flex align-items-center h-20px px-3'
                          type='button'
                          title='Воспроизвести сегмент'
                          onClick={(e) => {
                            playSegment(message.start!, message.end!)
                            e.currentTarget.blur()
                          }}
                        >
                          <i className='bi bi-play-fill fs-2' />
                          Воспроизвести
                        </button>
                        {/* <span className={clsx('badge h-20px', `bg-light-${state}`, 'text-gray-900', 'me-1')}></span> */}
                      </div>
                    </div>

                    <div
                      className={clsx(
                        'p-5 rounded',
                        `bg-light-${state}`,
                        'text-gray-900 fw-bold mw-lg-700px',
                        `text-${message.channel === 0 ? 'start' : 'end'}`
                      )}
                      data-kt-element='message-text'
                      dangerouslySetInnerHTML={{__html: message.text as string}}
                    ></div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export {TalkInnerTab}
